import { CardHeader } from "reactstrap";
import { H3 } from "../../../../AbstractElements";
import { ZeroConfiguration, ZeroConfiguration1, ZeroConfiguration2 } from "../../../../Constant";

const ZeroConfigurationHeader = () => {
  return (
    <CardHeader className="pb-0 card-no-border">
      <H3>{ZeroConfiguration}</H3>
      <span dangerouslySetInnerHTML={{ __html:  ZeroConfiguration1 }} />
      <span dangerouslySetInnerHTML={{ __html:  ZeroConfiguration2 }} />
    </CardHeader>
  )
};

export default ZeroConfigurationHeader;
